import { connect } from 'react-redux';
import { login } from './../actions/auth';
import LoginForm from '../components/auth/Login';

export default connect(
  (state) => ({
    message: state.auth.message
  }),
  //Dispatches
  (dispatch) => ({
    login: (userName, password, nextPathname) => dispatch(login(userName, password, nextPathname))
  })
)(LoginForm);



// WEBPACK FOOTER //
// ./src/containers/Login.js